import React, { Component } from "react";
// import TextField from '@material-ui/core/TextField';
import T from "i18n-react";
import "./AddressForm.css";
import { ReactComponent as AlertErrorIcon } from "../../../imges/AlertErrorIcon.svg";
import { AlertStatusCard } from "../../../yoello-lib/modules/components/UI/Alerts/AlertStatusCard";
class AddressForm extends Component {
  state = {
    full_name: "",
    address: "",
    city: "",
    postcode: "",
  };

  componentDidMount = () => {
    if (window.localStorage.getItem("BillingAddress")) {
      let address;
      if (typeof window.localStorage.getItem("BillingAddress") !== "object") {
        address = JSON.parse(window.localStorage.getItem("BillingAddress"));
      } else {
        address = window.localStorage.getItem("BillingAddress");
      }
      this.setState({
        full_name: address?.full_name,
        address: address?.address,
        city: address?.city,
        postcode: address?.postcode,
      });
      setTimeout(() => {
        this.props.handleDeliveryInfoChange(this.state);
      }, 200);
    }
  };

  handleInputChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({ [name]: value });
    if (name !== "full_name") {
      this.props.setPostCodeChanged(true);
    }
    setTimeout(() => {
      this.props.handleDeliveryInfoChange(this.state);
    }, 200);
  };

  render() {
    return (
      <div
        className="AddressForm"
        style={{
          height: this.props.noFullName ? "auto" : "",
        }}
      >
        {/* <T.p className="FormTitle mb-2" text={{ key: `Payment.EnterAddressText` }} /> */}

        {this.props.noFullName ? null : (
          <div
            className="SignUpInputDivs"
            style={{
              marginTop: "10px",
            }}
          >
            <input
              type="text"
              className="SignUpInput"
              placeholder={T.translate("Forms.FullName")}
              value={this.state.full_name}
              name="full_name"
              onChange={this.handleInputChange}
            />
          </div>
        )}

        <div
          className="SignUpInputDivs"
          style={{
            marginTop: "10px",
          }}
        >
          <input
            type="text"
            className="SignUpInput"
            placeholder={T.translate("Forms.StreetAddress")}
            value={this.state.address}
            name="address"
            onChange={this.handleInputChange}
          />
        </div>

        <div
          className="SignUpInputDivs"
          style={{
            marginTop: "10px",
          }}
        >
          <input
            type="text"
            className="SignUpInput"
            placeholder={T.translate("Forms.City")}
            value={this.state.city}
            name="city"
            onChange={this.handleInputChange}
          />
        </div>

        <div
          className="SignUpInputDivs"
          style={{
            marginTop: "10px",
          }}
        >
          <input
            type="text"
            className="SignUpInput"
            placeholder={T.translate("Forms.PostCode")}
            value={this.state.postcode}
            name="postcode"
            onChange={this.handleInputChange}
          />
        </div>
        <div className="mt-4">
          {this.props.postCodeInValid ? (
            <AlertStatusCard
              alertProps={{
                color: "error",
                icon: <AlertErrorIcon />,
                style: {
                  color: "#F65164",
                  borderRadius: "0.75rem",
                  fontWeight: 600,
                },
              }}
              alertTitle={T.translate("Forms.InvalidPostcode")}
              alertMessage={T.translate("Forms.EnterValidPostCode")}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

export default AddressForm;
